const globalActionConstants = {
  SET_LOADING_ON: 'SET_LOADING_ON',
  SET_LOADING_OFF: 'SET_LOADING_OFF',
};

export default globalActionConstants;
